const dynamicDrawers = {
  ExternalMessageDetail: () => import("@/models/external_messages/externalMessageDetail"),
  CardTestDeviceDetail: () => import("@/models/settings/test_devices/components/cardTestDeviceDetail"),
  SelectTestDevices: () => import("@/models/settings/test_devices/components/selectTestDevices"),
  priority: () => import("@/models/richmenu/components/priority"),
  list: () => import("@/models/list/detailDrawer.vue")
};

export default dynamicDrawers;
